import { formatRiskDecimal } from '@/utils';
import { Badge, BadgeProps, Text } from '@cmpsr/components';

type AboveAverageImpactBadgeProps = BadgeProps & {
  impact: number;
};

export default function AboveAverageImpactBadge({ impact, ...props }: AboveAverageImpactBadgeProps) {
  return (
    <Badge w="max-content" backgroundColor="alert-error-default" py="2px" {...props}>
      <Text color="text-error" variant="text-body-bold">
        {formatRiskDecimal(impact)}
      </Text>
    </Badge>
  );
}
